module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/no_image-713a98a269ca3fee8d41b8d0a6b21110.png";